// import BookingUpdatersReceipt from "../features/booking/BookingUpdatersReceipt";

import {progress} from "../data/progress/feature.progress.svelte.js";
import AppConfig from "../AppConfig.js";
import {ENVIRONMENT_DEVARANA} from "../AppConstants.js";

class RoutingUtil {
  // static bDebug = true;

  static getURLSegmentForStep = (iStep) => {
    let aStepToRouteMap = {};

    const sHost = window.location.hostname;
    if ( sHost === 'localhost' )
    {
      aStepToRouteMap = {
        10: "/",
        14: "/entree-type",
        17: "/gezelschap",
        20: "/datum",
        30: "/tijd",
        40: "/arrangementen",
        50: "/behandelingen",
        60: "/gegevens",
        70: "/betaling"
      };
    }
    else
    {
      aStepToRouteMap = {
        10: "/reserveren/",
        14: "/reserveren/entree-type",
        17: "/reserveren/gezelschap",
        20: "/reserveren/datum",
        30: "/reserveren/tijd",
        40: "/reserveren/arrangementen",
        50: "/reserveren/behandelingen",
        60: "/reserveren/gegevens",
        70: "/reserveren/betaling"
      };
    }

    //console.log('getURLSegmentForStep:', iStep, aStepToRouteMap[iStep]);
    if ( typeof aStepToRouteMap[iStep] !== "undefined" )
    {
      return aStepToRouteMap[iStep];
    }

    return false;
  }

  static getStepForURLSegment = (sURLSegment) => {
    //console.log('sURLSegment:', sURLSegment);
    const aStepMapping = {
      "/": 10,
      "/reserveren/": 10,
      "/entree-type": 14,
      "/reserveren/entree-type": 14,
      "/gezelschap": 17,
      "/reserveren/gezelschap": 17,
      "/datum": 20,
      "/reserveren/datum": 20,
      "/tijd": 30,
      "/reserveren/tijd": 30,
      "/arrangementen": 40,
      "/reserveren/arrangementen": 40,
      "/behandelingen": 50,
      "/reserveren/behandelingen": 50,
      "/gegevens": 60,
      "/reserveren/gegevens": 60,
      "/betaling": 70,
      "/reserveren/betaling": 70
    };

    if ( typeof aStepMapping[sURLSegment] !== "undefined" )
    {
      return aStepMapping[sURLSegment];
    }

    return false;
  }

  static getEnvFromHost = (sHostName = '') => {
    if ( sHostName === '' )
    {
      sHostName = window.location.hostname;
    }

    if ( AppConfig.aHostToEnvMap[sHostName] )
    {
      return AppConfig.aHostToEnvMap[sHostName];
    }

    return ENVIRONMENT_DEVARANA;
  }

  static appendWebshopStyleSheetToPage = (fnCallbackAfterLoad = () => {
  }) => {
    return new Promise((resolve) => {
      const sDefaultTheme = 'is-denilp';
      const sHost = window.location.hostname;

      if ( sHost === 'localhost' )
      {
        progress.bIsLocal = true;
      }

      let sEnv = RoutingUtil.getEnvFromHost(sHost);

      const aHostToThemeMap = {
        "dvr": "is-devarana",
        "di": "is-denilp",
        "rr": "is-rr",
        "sl": "is-sl"
      };

      if ( aHostToThemeMap[sEnv] )
      {
        document.body.classList.add(aHostToThemeMap[sEnv]);
      }
      else
      {
        document.body.classList.add(sDefaultTheme);
      }

      // CSS file toevoegen
      var sBasePath = '../_resources/app/client/css/';

      if ( sHost === 'localhost' )
      {
        sBasePath = '../public/_resources/app/client/css/';
      }

      let stylesheet = '';

      // if ( sHost === 'localhost' )
      // {
      // dev-server proxy heeft public/ prefix nodig
      // stylesheet = "public/_resources/app/client/css/webshop-den-ilp.css?" + Date.now();
      // stylesheet = "public/_resources/app/client/css/webshop-ridderrode.css?" + Date.now();
      // }
      // else
      // {
      const styles = {
        "dvr": sBasePath + "webshop-devarana.css?" + Date.now(),
        "di": sBasePath + "webshop-den-ilp.css?" + Date.now(),
        "rr": sBasePath + "webshop-ridderrode.css?" + Date.now(),
        "sl": sBasePath + "webshop-sweetlake.css?" + Date.now(),
      };

      // Brands that use the new base+brand architecture
      const aBrandsWithBase = ["sl"];

      stylesheet = styles[sEnv] || "public/_resources/app/client/css/webshop-den-ilp.css?" + Date.now();

      /**
       * Helper: append a <link> stylesheet and return a Promise that resolves on load.
       */
      const fnLoadCSS = (sHref) => {
        return new Promise((fnResolveCSS) => {
          const link = document.createElement("link");
          link.rel = "stylesheet";
          link.href = sHref;
          link.onload = fnResolveCSS;
          document.head.appendChild(link);
        });
      };

      if ( aBrandsWithBase.includes(sEnv) )
      {
        // Load base first, then brand palette on top
        document.documentElement.dataset.brand = sEnv;
        const sBaseHref = sBasePath + "webshop-base.css?" + Date.now();

        fnLoadCSS(sBaseHref)
          .then(() => fnLoadCSS(stylesheet))
          .then(() => {
            resolve();
            if ( typeof fnCallbackAfterLoad === "function" ) fnCallbackAfterLoad();
          });
      }
      else
      {
        // Legacy brands: single stylesheet
        fnLoadCSS(stylesheet).then(() => {
          resolve();
          if ( typeof fnCallbackAfterLoad === "function" ) fnCallbackAfterLoad();
        });
      }
    });
  }
}

export default RoutingUtil;